export const UPLOAD_STATUS = {
    uploading: 1,
    done: 2,
    failed: 3,
};
